import { useMutation, useQueryClient } from '@tanstack/react-query';
import { myProfileApi } from '../api/myProfileApi';

/**
 * POST /api/eraf/me/avatar — 아바타 업로드
 * 성공 시 ['my-profile'] 쿼리 무효화 (profileImageUrl 갱신)
 */
export function useUploadAvatar() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => myProfileApi.uploadAvatar(file),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['my-profile'] });
    },
  });
}
